<template>
    <div>
        <div id="header-container" class="pl-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white">
                <h3 class="text-white">{{ $t('Beneficiaries') }}</h3>
                <span class="fz-16 fw-400">{{ $t('View your beneficiaries list here') }}</span>
            </div>
        </div>
        
        <b-container fluid class="pb-5">
            <b-row class="pt-3">
                <b-col cols="12">
                    <div id="body-container">
                        <div class="d-block d-md-flex align-items-center mb-2 p-2">
                            <h5 class="fz-22 fw-700">{{ $t('Beneficiaries List') }}</h5>
                            <button class="btn btn-primary ml-auto" @click="addPayee">+ {{ $t('Add Beneficiary') }}</button>
                        </div>
                        <PartnerList
                            v-if="userNo"
                            :userNo = "userNo"
                        ></PartnerList>
                        <!-- <b-tabs nav-wrapper-class="transaction-status mb-2 pb-0" v-model="tabIndex">
                            <b-tab :title="$t('Beneficiaries Same Name')" v-if="userNo">
                                <CompanyList
                                    :userNo = "userNo"
                                ></CompanyList>
                            </b-tab>
                            <b-tab :title="$t('Beneficiaries Different Name')" v-if="userNo">
                                <PartnerList
                                    :userNo = "userNo"
                                ></PartnerList>
                            </b-tab>
                        </b-tabs> -->
                    </div>
                </b-col>
            </b-row>     
      </b-container>

      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import BeneficiaryContact from "@/components/BeneficiaryContact";
    import BeneficiaryList from "@/components/BeneficiaryList";
    import PartnerList from "@/components/PartnerList";
    import CompanyList from "@/components/Companies/PartnerList";
    import CreateAccount from "@/services/CreateAccount";
    

    export default {
        name: 'beneficiaries',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                userNo:'',
                tabIndex:-1,
                selected:{}
            }
        },
        components: {
            LoaderComponent,
            BeneficiaryContact,
            BeneficiaryList,
            PartnerList,
            CompanyList
        },
        methods:{
            addPayee(){
                this.$router.push({ 
                    path: '/add-partner'
                });
            },
            withdrawNow(){
                this.$router.push({ 
                    path: '/withdrawal-type'
                });
            },
            addBeneficiary(){
                this.$router.push({ 
                    path: '/add-beneficiary'
                });
            },
            checkError(err){
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            this.$notify({
                                type: 'warn',
                                text: response.data.message
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$notify({
                                    type: 'warn',
                                    text: response.data.message['errorMsg']
                                });
                            }
                            else{
                                let ret = [];
                                Object.keys(response.data.message).forEach((key) => {
                                    ret.push(response.data.message[key][0]);
                                });

                                this.$notify({
                                    type: 'warn',
                                    html: ret.join("<br>")
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            }
        },
        mounted(){
            let self = this;
            this.$nextTick(() => {
                CreateAccount.list().then((response)=>{
                    if (response.status == 200) {
                        let account = response.data.data;
                        if(account){
                            account.forEach(element => {
                                if(element.status == 2){
                                    self.selected = element;
                                    self.userNo = self.selected.userNo;
                                }
                            });
                        }
                    }
                });
            });
        }
    };
  </script>

<style>
.block-list-history{
    background-color: #F8F9FA;
    padding: 20px 15px !important;
    border-radius: 8px;
}
</style>
